import { topicRepository } from "../../../providers/repositories/topicRepository";
import { Topic } from "../entities/Topic";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const getTopicByIdUseCase = {
    async exec(id: number | string): Promise<Topic | null> {
        try {
            return await topicRepository.getOne(id);
        } catch (error) {
            toast.error(t("action.error"));
            Logger.error("getTopicByIdUseCase", error);
        }
        return null;
    },
};
